import { render } from "./docsPcIndex.vue?vue&type=template&id=0539332b"
import script from "./docsPcIndex.vue?vue&type=script&lang=js"
export * from "./docsPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__